export default __webpack_public_path__ + "static/media/referral-claim-desktop@2x.c2fe4e27.png";